export var VideoStatusCode;

(function (VideoStatusCode) {
  VideoStatusCode[VideoStatusCode["not_found"] = 404] = "not_found";
  VideoStatusCode[VideoStatusCode["in_process"] = 409] = "in_process";
  VideoStatusCode[VideoStatusCode["codecErorr"] = 410] = "codecErorr";
  VideoStatusCode[VideoStatusCode["private"] = 441] = "private";
  VideoStatusCode[VideoStatusCode["processingError"] = 442] = "processingError";
  VideoStatusCode[VideoStatusCode["protected"] = 444] = "protected";
  VideoStatusCode[VideoStatusCode["no_video"] = 455] = "no_video";
  VideoStatusCode[VideoStatusCode["blocked"] = 477] = "blocked";
  VideoStatusCode["default"] = "Video unavailable";
})(VideoStatusCode || (VideoStatusCode = {}));